import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useAppSelector } from '../../store';
import InfoDialog from '../shared/InfoDialog';
import ThreeGroup from '../../views/groups/ThreeGroup';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CusTooltip from '../material-ui/CusTooltip';
import CusButton from '../material-ui/CusButton';
import ShowContainer from '../material-ui/ShowContainer';
import useGroupThree from '../../hooks/site/useGroupThree';
import { ENUM_CUS_EVENT, TEST_MODE } from '../../enums/enums';
import { dispatchCusEvent } from '../../utils';

export default function SelectGroup({
  title = 'Default group',
  direction = 'row',
  selectGroupId,
  hideTooltip,
  isSelectNode = true,
  hideTitle,
  readOnly,
  setSelectGroupId
}) {
  const { t } = useTranslation();
  const { updateThree, updateChildrenGroup } = useGroupThree();

  const groupHash = useAppSelector((state) => state.user.group.hash);
  const mainGroupId = useAppSelector((state) => state.user.group.main?.groupId);

  const [openThree, setOpenThree] = useState(false);
  const [chooseGroupeId, setChooseGroupeId] = useState(selectGroupId);
  const [expandedItems, setExpandedItems] = useState([String(chooseGroupeId)]);
  const [selectedItems, setSelectedItems] = useState([]);

  const groupName = groupHash[selectGroupId]?.name;

  useLayoutEffect(() => {
    if (TEST_MODE) return;
    if (!chooseGroupeId) return;
    if (!openThree) return;

    updateThree({ selectGroupId: chooseGroupeId, setExpandedItems, setSelectedItems });
    updateChildrenGroup(chooseGroupeId);
  }, [chooseGroupeId, openThree]);

  useEffect(() => {
    if (!selectGroupId) {
      setChooseGroupeId(String(mainGroupId));
      return;
    }
    setChooseGroupeId(selectGroupId);
  }, [selectGroupId, mainGroupId]);

  useEffect(() => {
    if (!selectGroupId) return;
    if (groupName) return;

    dispatchCusEvent(ENUM_CUS_EVENT.getGroupData, { groupId: selectGroupId });
  }, [groupName, selectGroupId]);

  return (
    <>
      <Stack
        display="flex"
        direction={direction}
        gap={0.5}
        alignItems={direction == 'row' ? 'center' : 'start'}>
        <ShowContainer condition={!hideTitle}>
          <Stack gap={1} direction={'row'}>
            <Typography>{t(title)}</Typography>{' '}
            <ShowContainer condition={!hideTooltip}>
              <CusTooltip
                text={
                  'Players are registered in this group by default, for example, if they visited the site (TG bot) without a referral link.'
                }
              />
            </ShowContainer>
          </Stack>
        </ShowContainer>
        <Stack
          display={'flex'}
          direction={'row'}
          pt={0}
          gap={1}
          alignItems={'center'}
          ml={direction == 'row' ? 2 : 0}>
          <Typography fontWeight={600} fontSize={16} component="span" minHeight={20}>
            {groupName}
          </Typography>
          <CusButton
            fullWidth
            text={groupName ? 'Change' : 'Select'}
            variant="outlined"
            onClick={() => setOpenThree(true)}
            sx={{ minWidth: 150 }}
            disabled={readOnly}
          />
        </Stack>
      </Stack>

      <InfoDialog
        open={openThree}
        onClose={() => setOpenThree(false)}
        title={title}
        contentSx={{ minHeight: '350px' }}>
        <ThreeGroup
          setClickedGroupId={(groupId) => {
            // setClickedGroupId(groupId);
            const clickedGroup = groupHash[groupId] || {};

            if (clickedGroup.game || isSelectNode) {
              setSelectGroupId(groupId);
              setOpenThree(false);
            }
          }}
          // chooseGroupId={clickedGroupId}
          selectedItems={selectedItems}
          expandedItems={expandedItems}
          setChooseGroupeId={setChooseGroupeId}
          setSelectedItems={setSelectedItems}
          setExpandedItems={setExpandedItems}
          viewId
          isManualUpdate
        />
      </InfoDialog>
    </>
  );
}
